import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/quiz';

export default createReducer(state, {
  SET_QUIZ_DATA: (state, { data }) => Immutable({ ...state, quizData: data }),
  SET_QUIZ_STATE: (state, { data }) => Immutable({ ...state, quizState: data }),
});
